import { useSelector, TypedUseSelectorHook } from 'react-redux';

import type { StoreState } from '@common/types/store';

export const useAppSelector: TypedUseSelectorHook<StoreState> = useSelector;
